<section class="block margin--bottom-l margin--top-l" *ngIf="!environment.production">
  <div class="label label--error caps">COMPONENT "{{ data?.__component }}" IS NOT CONFIGURED</div>
</section>
